import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  userService,
  pmDataService
} from 'app/services';
import {
  alerts,
  stringToNumber,
  ssAutocomplete
} from 'app/components/global';
import controller from './settings-dialog.controller';
import template from './settings-dialog.html';

// Validation
import variablesMessagesTpl from './messages/variables.messages.html';
import phoneMessagesTpl from './messages/phone.messages.html';
import emailMessagesTpl from './messages/email.messages.html';

class dialogService {
  getOptions($event, {
    variables,
    emptyVariables = [],
    settings = [],
    users = [],
    vendors = [],
  }) {
    return {
      controller,
      controllerAs: 'policyManagementSettingsDialogVM',
      locals: {
        variables,
        emptyVariables,
        settings,
        users,
        vendors,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.settingsDialog', [
  alerts,
  stringToNumber,
  constants,
  loaderService,
  ssDialogService,
  userService,
  pmDataService,
  ssAutocomplete
])
  .service('policyManagementSettingsDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('variables.messages.html', variablesMessagesTpl);
    $templateCache.put('phone.messages.html', phoneMessagesTpl);
    $templateCache.put('email.messages.html', emailMessagesTpl);
  })
  .name;
